var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"quillEditor",staticClass:"richtext-editor",attrs:{"content":_vm.value,"options":_vm.EDITOR_OPTIONS},on:{"change":function($event){return _vm.onEditorChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }